import { HomeCard } from '@fullstory/proto/fs/services/dx-objects';
import { UserBase, UserFeedback } from '../user';
import { createEventTracker } from '../util';
import {
  HomeSectionSave,
  HomeSectionAdd,
  HomeCardReorder,
  HomeNavigate,
  PagesMLStateChange,
} from './types';
import { CardAnalytics, CardRemoveAnalytics } from '../cards';
import { SpecAnalytics } from '../specUtils';

export const trackHomeSubmitFeedback = createEventTracker<UserFeedback>(
  'Submitted Product Feedback',
);
export const trackHomeSectionSaved = createEventTracker<HomeSectionSave>('Home Section Saved');
export const trackHomeSectionAdded = createEventTracker<HomeSectionAdd>('Home Section Added');
export const trackHomeCardAdded = createEventTracker<CardAnalytics & SpecAnalytics & UserBase>(
  'Home Card Added',
);
export const trackHomeCardDuplicated = createEventTracker<CardAnalytics & UserBase>(
  'Home Card Duplicated',
);
export const trackHomeCardUpdated = createEventTracker<CardAnalytics & UserBase>(
  'Home Card Updated',
);
export const trackHomeCardDeleted = createEventTracker<CardRemoveAnalytics & UserBase>(
  'Home Card Deleted',
);

export const trackHomeCardReordered = createEventTracker<HomeCardReorder>('Home Card Reorder');
export const trackHomeNavigated = createEventTracker<HomeNavigate>('Home Navigate');
export const trackPagesMLStateChanged =
  createEventTracker<PagesMLStateChange>('Pages ML State Changed');

export const homeCardFormatToString = (format: HomeCard.Format) => {
  switch (format) {
    case HomeCard.Format.FORMAT_INVALID:
      return 'invalid';
    case HomeCard.Format.FORMAT_SMALL:
      return 'small';
    case HomeCard.Format.FORMAT_MEDIUM:
      return 'medium';
    case HomeCard.Format.FORMAT_LARGE:
      return 'large';
    case HomeCard.Format.FORMAT_PLAYLIST:
      return 'playlist';
  }
};
